import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckHistorySummary } from '@api/consistencyCheckParameters';

import { extractQueryParams } from '@utils/common';

import { IConsistencyCheckHistorySummary } from '@interfaces/cmModule/consistencyCheck';
import { TConsistencyCheckHistoryStatisticsDTO } from '@interfaces/cmModule/dto/consistencyCheckDTO';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_CHECK_HISTORY } from '@constants/queryKeys';

interface IUseConsistencyCheckHistorySummaryReturned {
	consistencyCheckHistorySummary: IConsistencyCheckHistorySummary[];
	countOfRecords: number;
	isLoadingConsistencyCheckHistorySummary: boolean;
}

const useConsistencyCheckHistorySummary = (
	params: TConsistencyCheckHistoryStatisticsDTO,
): IUseConsistencyCheckHistorySummaryReturned => {
	const {
		data,
		isInitialLoading,
		isFetching,
	} = useQuery({
		queryKey: [CONSISTENCY_CHECK_HISTORY, params],
		queryFn: extractQueryParams(getConsistencyCheckHistorySummary),
		enabled: [
			!!params.page,
			!!params.pageSize,
		],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		consistencyCheckHistorySummary: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoadingConsistencyCheckHistorySummary: isInitialLoading || isFetching,
	};
};

export default useConsistencyCheckHistorySummary;
